import { useState, React, useEffect } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import ConfirmDeactivate from '../../common/components/ConfirmDeactivate/ConfirmDeactivate';
import {
    applicableFlowTypes,
    currentFlowTypeEnum,
} from '../../common/components/constants';

const DeleteProgramModal = ({
    isVisible,
    closeModal,
    programData,
    currentFlow,
    selectedWorkspace,
    getAllPrograms,
    updateProgram,
    updatingProgramStatus,
    updateProgramStatusSuccess,
}) => {
    const [loadPrograms, setLoadPrograms] = useState(false);

    useEffect(() => {
        if (updateProgramStatusSuccess && loadPrograms) {
            closeModal();
            getAllPrograms({
                workspaceId: selectedWorkspace?.workspace_id ?? '',
                flowType: currentFlow,
            });
            setLoadPrograms(false);
        }
    }, [
        updateProgramStatusSuccess,
        loadPrograms,
        closeModal,
        getAllPrograms,
        selectedWorkspace,
        currentFlow,
    ]);

    const handleAccept = () => {
        const body = {
            company_id: selectedWorkspace?.company_id,
            workspace_id: selectedWorkspace?.workspace_id,
            program_id: programData?.program_id,
            program_status: 3,
        };
        updateProgram(body);
        setLoadPrograms(true);
        closeModal();
    };

    return (
      <ConfirmDeactivate
        isVisible={isVisible}
        warning
        title={`Delete '${programData?.name}'?`}
        message='This meal plan will be permanently deleted and cannot be recovered.'
        buttonLabel='Yes, Delete'
        denyButtonLabel='Cancel'
        closeModal={closeModal}
        onContinueClick={handleAccept}
        loading={updatingProgramStatus}
      />
    );
};

DeleteProgramModal.propTypes = {
    isVisible: PropTypes.bool,
    closeModal: PropTypes.func,
    programData: PropTypes.objectOf(PropTypes.any),
    currentFlow: PropTypes.oneOf(applicableFlowTypes),
    selectedWorkspace: PropTypes.objectOf(PropTypes.any),
    getAllPrograms: PropTypes.func,
    updateProgram: PropTypes.func,
    updatingProgramStatus: PropTypes.bool,
    updateProgramStatusSuccess: PropTypes.bool,
};

DeleteProgramModal.defaultProps = {
    isVisible: false,
    closeModal: _noop,
    programData: {},
    currentFlow: currentFlowTypeEnum.FLOW_TYPE_LIMIT,
    selectedWorkspace: {},
    getAllPrograms: _noop,
    updateProgram: _noop,
    updatingProgramStatus: false,
    updateProgramStatusSuccess: false,
};

export default DeleteProgramModal;
